module.exports = __webpack_public_path__ + "img/level_four.f396b8c5.png";